import { __awaiter } from "tslib";
import { authPhx, loginWithTwoFactorCode, requestTwoFactorLoginCode, } from "../../../../shared/functions/fns.auth";
import { text, isValidInput, getBtnStatusClass, } from "@phoenixreisen/form";
import { SessionStore } from "../../../../shared/functions/fns.store";
import { getReferrer } from "../../../../shared/functions/fns.misc";
import { getLinkList } from "../../../../shared/functions/fns.nav";
import User from "@phoenixreisen/user";
import Model from "../model";
import m from "mithril";
import { setHasTokenRenewedAt } from "@phoenixreisen/frontend-lib";
const Link = m.route.Link;
function redirectAfterLogin(urlParam) {
    return __awaiter(this, void 0, void 0, function* () {
        const links = yield getLinkList();
        const referrer = getReferrer();
        if (urlParam) {
            for (const link of links) {
                if (link.id === urlParam) {
                    window.location.href = link.href;
                    return;
                }
            }
        }
        if (referrer && !referrer.includes("/cdn/mein-phoenix/login/")) {
            SessionStore === null || SessionStore === void 0 ? void 0 : SessionStore.remove("referrer");
            window.location.href = referrer;
            return;
        }
        User.load();
        m.route.set("/hub");
    });
}
export function requestTwoFactorCode(state, username, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            state.submitting = true;
            const result = yield requestTwoFactorLoginCode(username, jwt);
            state.twoAuthResponse = result;
        }
        catch (e) {
            const error = e;
            state.error = Error(error["userfriendly-message"]);
            console.error(JSON.stringify(e));
        }
        finally {
            state.submitting = false;
            m.redraw();
        }
    });
}
const submitNameAndPassword = (state, attrs, e) => __awaiter(void 0, void 0, void 0, function* () {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    const { name, pwd } = state.fields;
    const { twoAuthFields, twoAuthResponse } = state;
    const { username, jwt, twoFactorCode } = state.twoAuthFields;
    state.error = null;
    state.submitting = false;
    if (isValidInput(state.fields)) {
        try {
            state.submitting = true;
            if (twoAuthResponse) {
                if (isValidInput(twoAuthFields)) {
                    yield loginWithTwoFactorCode(username.value(), twoFactorCode.value(), jwt.value());
                    yield redirectAfterLogin(attrs.app);
                }
                else {
                    state.error = Error("Bitte Code eingeben.");
                }
            }
            else {
                yield authPhx(name.value(), pwd.value());
                setHasTokenRenewedAt();
                yield redirectAfterLogin(attrs.app);
            }
        }
        catch (e) {
            const error = e;
            if (error["userfriendly-message"]) {
                state.error = Error(error["userfriendly-message"]);
            }
            else {
                switch (error["status"]) {
                    case "two-factor-auth-required":
                        if (!error.username) {
                            state.error = Error("Du kannst nicht angemeldet werden. Bitte setze dich mit der IT in Verbindung.");
                        }
                        else {
                            jwt.value(error.jwt);
                            username.value(error.username);
                            yield requestTwoFactorCode(state, error.username, error.jwt);
                        }
                        break;
                    case "wrong-username-password":
                        state.error = Error("Benutzername oder Passwort falsch.");
                        break;
                    case "blocked":
                        state.error = Error("Dein Account wurde für einige Minuten gesperrt.");
                        break;
                    case "unallowed-subnet":
                        state.error = Error("Um dich anmelden zu können, musst du dich in einem Phoenix Netzwerk befinden.");
                        break;
                    default:
                        state.error = Error("Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.");
                        console.error(JSON.stringify(e));
                }
            }
        }
        finally {
            state.submitting = false;
            m.redraw();
        }
    }
    else {
        state.error = Error("Bitte alle Felder ausfüllen.");
    }
});
const View = {
    oninit({ state }) {
        const isRequired = true;
        state.fields = {
            pwd: text(isRequired),
            name: text(isRequired),
        };
        state.twoAuthFields = {
            jwt: text(isRequired),
            username: text(isRequired),
            twoFactorCode: text(isRequired),
        };
        state.error = null;
        state.submitting = false;
    },
    view({ state, attrs }) {
        const { error } = state;
        const { webtexte } = Model;
        const { twoAuthResponse } = state;
        const { name, pwd } = state.fields;
        const { twoFactorCode } = state.twoAuthFields;
        const btnStatusClass = getBtnStatusClass(false, error);
        return (m("div", null,
            m("form", { class: "form login-form jackInTheBox animated fast", onsubmit: (e) => submitNameAndPassword(state, attrs, e) },
                m("h5", { class: "tc pv2 mb2 gray6" }, "Anmelden"),
                !User.online ? (m("article", { class: "alert alert--danger alert--icon" },
                    m("i", { class: "fas fa-exclamation-triangle" }),
                    "Du bist offline.")) : (webtexte &&
                    webtexte["ma_login__infosatz"] && (m("article", null, m.trust(webtexte["ma_login__infosatz"])))),
                error && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger alert--icon mb3" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        error.message))),
                m("div", { class: "textfield--custom" },
                    m("label", { htmlFor: "feld-benutzername", class: `${name.complaint ? "alert--warning" : ""}` }, "Benutzername"),
                    m("input", { id: "feld-benutzername", type: "text", maxLength: "30", name: "phxusername", value: name.value(), autocomplete: "username", placeholder: "z.B. Fabian", disabled: !!twoAuthResponse, oninput: (e) => name.validate(e.target.value.replace(/\s/g, "")) })),
                m("div", { class: "textfield--custom" },
                    m("label", { htmlFor: "feld-passwort", class: `${pwd.complaint ? "alert--warning" : ""}` }, "Passwort"),
                    m("input", { id: "feld-passwort", maxLength: "30", type: "password", name: "phxpasswort", value: pwd.value(), placeholder: "dein Passwort...", disabled: !!twoAuthResponse, oninput: (e) => pwd.validate(e.target.value) })),
                !!twoAuthResponse && (m("p", { class: "alert alert--info alert--icon" },
                    m("i", { class: "fas fa-info-circle" }),
                    "Es wurde ein ",
                    m("strong", null, "Code"),
                    " per",
                    " ",
                    m("strong", null, twoAuthResponse["two-factor-auth-chan"]),
                    " an die Nummer",
                    " ",
                    m("strong", null, twoAuthResponse["two-factor-auth-addr-scrambled"]),
                    " ",
                    "geschickt. Diesen bitte hier eingeben.")),
                !!twoAuthResponse && (m("label", { class: "textfield" },
                    m("input", { maxLength: "30", name: "smscode", type: "password", placeholder: "dein Code...", value: twoFactorCode.value(), oninput: (e) => twoFactorCode.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${twoFactorCode.complaint ? "alert--warning" : ""}` }, "SMS Code"))),
                m("div", { class: "tr" },
                    !twoAuthResponse && (m(Link, { class: "btn btn--link mr1", href: "/zuruecksetzen", title: "neues Passwort setzen" },
                        m("small", null, "Passwort vergessen?"))),
                    m("button", { type: "submit", class: `btn ${btnStatusClass} ml1`, disabled: state.submitting || !User.online },
                        state.submitting ? (m("i", { class: "fas fa-spinner fa-spin mr2" })) : (m("i", { class: "fas fa-sign-in-alt mr2" })),
                        m("span", null, "Anmelden"))))));
    },
};
export default View;
